﻿/**
 * portal-admin-links.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-admin-links.controller', portalAdminLinksController);

	/** setup injection */
	portalAdminLinksController.$inject = ['$sce', '$uibModal', 'portal-link.repository'];

	/** implementation */
	function portalAdminLinksController($sce, $uibModal, portalLinkRepo)
	{
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.links = [];

		/** public methods */
		vm.openLinkModal = openLinkModal;
		vm.getSVG = getSVG;

		/** run init */
		init();

		/** public method implementations */

		/** open a modal for link editing */
		function openLinkModal(link) {
			/** create the modal instance */
			$uibModal.open({
				templateUrl: 'app/portal-admin/portal-admin-links/link-modal.html',
				controller: 'link-modal.controller',
				controllerAs: 'linkModalCtrl',
				size: 'lg',
				resolve: {
					portalLink: function() {
						return link;
					},
					parentInit: function() {
						return init;
					}
				}
			});
		}

		/** get the svg value */
		function getSVG(iconSVG) {
			return $sce.trustAsHtml(iconSVG);
		}

		/** private methods */

		/** initialize */
		function init() {
			/** flip loading flag */
			vm.loading = true;

			/** load links */
			portalLinkRepo.getAll({ 'filter': {}, 'orderby': 'PortalLinkName' }).then(function(links) {
				/** get todays day of the year */
				var today = moment();

				/** check how new each link is */
				_.forEach(links, function(l) {
					/** get the created/modified day of the year */
					var createdDayOfYear = moment(l.createDate);

					/** add an isModified flag */
					l.changeDaysAgo = today.diff(createdDayOfYear, 'days');
				});

				/** set links */
				vm.links = links;

				/** flip loading flag */
				vm.loading = false;
			});
		}
	}
})();